import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {
  SERVER_API_URL,
  SIGNATURE_API_KEY,
  SIGNATURE_API_URL,
} from '@app/app.constants';
import { IProperty } from '@app/@shared/model/property.model';
import { IcounterOffer } from '@app/@shared/model/counter-offer.model';
import { createRequestOption } from '../web/request-util';

@Injectable({
  providedIn: 'root',
})
export class PropertiesService {
  constructor(private http: HttpClient) {}

  postCountVisits(data: any): Observable<any> {
    return this.http.post(SERVER_API_URL + 'properties/count-visit', data);
  }

  SendEmail(mail: any) {
    return this.http.put(`${SERVER_API_URL}auth/revalidate`, mail);
  }

  getProperties(req: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get(SERVER_API_URL + 'properties/', {
      params: options,
      observe: 'response',
    });
  }
  getPropertyType(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'properties/types');
  }
  getAvailabilities(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'properties/availabilities');
  }
  getOrientations(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'properties/orientations');
  }
  getUsageStatuss(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'properties/usage-status');
  }
  getProvinces(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'locations/provinces');
  }
  getLocationsByProvince(idProvince: number): Observable<any> {
    return this.http.get(
      SERVER_API_URL + `locations/municipalities/${idProvince}`
    );
  }
  getZoneByLocation(idLocation: number): Observable<any> {
    return this.http.get(SERVER_API_URL + `locations/zones/${idLocation}`);
  }
  getLocations(): Observable<any> {
    return this.http.get(SERVER_API_URL + `locations/municipalities`);
  }
  getTypesStreet(): Observable<any> {
    return this.http.get(SERVER_API_URL + `locations/street-types`);
  }

  getEmail(Email: any): Observable<any> {
    return this.http.get(SERVER_API_URL + `users/exist-email/${Email}`);
  }

  registerEmail(data: any, needPassword: boolean = false): Observable<any> {
    data.page = {
      url: window.location.href,
      title: document.title,
    };
    return this.http.post(
      SERVER_API_URL +
        `users/not-validated${needPassword ? '?needPassword=1' : ''}`,
      data
    );
  }

  editUserPersonData(data: any): Observable<any> {
    data.page = {
      url: window.location.href,
      title: document.title,
    };
    return this.http.post(SERVER_API_URL + `users/edit-user-person`, data);
  }

  registerOffer(offer: any): Observable<any> {
    return this.http.post(SERVER_API_URL + 'properties/offer', offer, {
      observe: 'response',
    });
  }

  registerCounterOffer(counterOffer: IcounterOffer): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/offer/counter-offer',
      counterOffer,
      { observe: 'response' }
    );
  }

  registerProperty(property: IProperty): Observable<any> {
    return this.http.post(SERVER_API_URL + 'properties', property, {
      observe: 'response',
    });
  }
  changeConditionProperty(property: any): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/property-change-condition',
      property,
      { observe: 'response' }
    );
  }
  registerDocuments(documents: any): Observable<any> {
    return this.http.post(SERVER_API_URL + 'properties/documents', documents, {
      observe: 'response',
    });
  }
  registerPropertyDocuments(documents: any): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/property-documents',
      documents,
      { observe: 'response' }
    );
  }
  registerOfferDocuments(documents: any): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/offer-documents',
      documents,
      { observe: 'response' }
    );
  }
  getPropertyById(id: number): Observable<IProperty> {
    return this.http.get(SERVER_API_URL + `properties/${id}`);
  }
  postUserFavoriteProperties(favorite: any): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/user-favorites',
      favorite
    );
  }
  getUserFavoriteProperties(userId: any, type?: any): Observable<any> {
    return this.http.get(
      SERVER_API_URL + `properties/user-favorites/${userId}`,
      {
        params: type,
      }
    );
  }
  deleteUserFavoriteProperties(id: any): Observable<any> {
    return this.http.delete(SERVER_API_URL + `properties/user-favorites/${id}`);
  }

  registerPropertyInfo(property: any): Observable<any> {
    return this.http.post(
      SERVER_API_URL + 'properties/flap-general-info',
      property
    );
  }

  getOffersByUser(userId: string, filters: any): Observable<any> {
    return this.http.get(
      SERVER_API_URL + `properties/offers/offer-by-user/${userId}`,
      {
        params: filters,
        observe: 'response',
      }
    );
  }

  getOfferByUser(userId: string, propertyId: number): Observable<any> {
    return this.http.get(
      SERVER_API_URL + `properties/offer/${userId}/${propertyId}`
    );
  }

  getOffer(
    propertyId: string,
    offerId: string,
    idOfferer: string
  ): Observable<any> {
    return this.http.get(
      SERVER_API_URL +
        `properties/${propertyId}/offer/${offerId}/detail-offer/${idOfferer}`
    );
  }

  getPropertyDocument(idProperty: number, idDocument: number): Observable<any> {
    return this.http.get(
      SERVER_API_URL + `properties/${idProperty}/documents/${idDocument}`
    );
  }
  getDocumentByProperty(idProperty: number): Observable<any> {
    return this.http.get(SERVER_API_URL + `properties/${idProperty}/documents`);
  }
  getCEERating(): Observable<any> {
    return this.http.get(SERVER_API_URL + `properties/cee-ratings`);
  }
  getAllPublications(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'sitemap/publication-properties');
  }
  getAllProvinces(): Observable<any> {
    return this.http.get(SERVER_API_URL + 'sitemap/locations');
  }
  getInvestorsProperties(idUser: number): Observable<any> {
    return this.http.get(SERVER_API_URL + `properties/user/${idUser}`, {
      observe: 'response',
    });
  }

  sendSignatureEmail(info: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + SIGNATURE_API_KEY,
      }),
    };
    return this.http.post<any>(
      SIGNATURE_API_URL + '/signatures.json',
      info,
      httpOptions
    );
  }

  saveStatusSignaturit(info: any): Observable<any> {
    return this.http.post<any>(
      SERVER_API_URL + `properties/document-signaturit`,
      info
    );
  }
}
